import { connect } from 'react-redux'
import Exports from './Exports'
import { setExportId, getExports, resetState } from './module'

const mapActionCreators = {
  setExportId,
  getExports,
  resetState,
}

const mapStateToProps = state => ({
  url: state.exports.url,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(Exports)



// WEBPACK FOOTER //
// ./src/legacy/pages/Exports/container.js